import { FilterConfig } from "../../../components/Tables/advancedRecord/FilterBar";

/**
 * Construye la configuración de filtros para la consulta de traslados de inventario.
 */
export const buildInventoryTransferFilters = (
  branchDropdown: { id: number; name: string }[],
  productDropdown: { id: number; name: string }[],
  statusOptions: { id: string; name: string }[]
): FilterConfig[] => [
  {
    name: "branchId",
    label: "Sucursal (Origen o Destino)",
    type: "searchSelect",
    options: branchDropdown.map((b) => ({
      id: b.id,
      name: b.name,
    })),
    colSpan: 4,
  },

  {
    name: "productId",
    label: "Producto",
    type: "searchSelect",
    options: productDropdown.map((p) => ({
      id: p.id,
      name: p.name,
    })),
    colSpan: 3,
  },

  {
    name: "status",
    label: "Estado",
    type: "select",
    options: statusOptions,
    colSpan: 2,
  },

  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    colSpan: 3,
  },

  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    colSpan: 3,
  },
];